// extracted by mini-css-extract-plugin
export default {"cls1":"_3ysHo2Yzu_AYBE8a41o","cls2":"uoFsYz8hNoOvIOKku3EO _3ysHo2Yzu_AYBE8a41o","isFilled":"DDe6jHzpSNCOWH7rccSK"};